import Checkbox, { CheckboxProps } from './Checkbox'

type Props = Omit<CheckboxProps, 'radio' | 'toggle'>

const Radio = (props: Props) => <Checkbox radio {...props} />

export default Radio

export type { Props as RadioProps }
